import blog1 from "./imgs/01.jpg";
import blog2 from './imgs/02.jpg'
import blog3 from "./imgs/03.jpg";

const Data = [
  {
    img: blog1,
    title: "Rainbow Vegetable Sandwich",
    time: "10-15 min",
    price: "10.50$",
  },
  {
    img: blog2,
    title: "Vegetarian Burger",
    time: "30-45 min",
    price: "20.00$",
  },
  {
    img: blog3,
    title: "Raspberry Stuffed French Toast",
    time: "20-25 min",
    price: "15.00",
  },
];

export default Data